document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    const label = e.target.closest('label');
    if (!label) return;

    const input = label.querySelector('input[data-radio-type="one_time_purchase"]');
    if (!input) return;

    e.preventDefault(); 
    e.stopPropagation();

    const variantId = input.dataset.variantId;
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(res => res.json())
    .then(() => {
      window.eventBus.emit('render:cart:drawer');
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
    })
    .catch(console.error);
  });

  const productForm = document.querySelector('form[action="/cart/add"]') || document.querySelector('.product-form');

  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      const oneTimeInput = document.querySelector('input[data-radio-type="one_time_purchase"]:checked');

      if (oneTimeInput) {
        e.preventDefault();
        return;
      }
    });
  }
});

let lastCartState = null;

function pollCartChanges() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartString = JSON.stringify(cart.items.map(i => ({ id: i.id, quantity: i.quantity })));
      if (cartString !== lastCartState) {
        lastCartState = cartString;
      }
    })
    .catch(console.error);

  setTimeout(pollCartChanges, 1000);
}

pollCartChanges();
